import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import Wizard from '@src/pages/wizard/wizard'

@Component
export default class CheckupWizard extends Vue {

  protected checkupAction: string = ''

  constructor () {
    super()
  }

  closeBuilder () {
    this.$store.dispatch('changeStep', null)
    this.$router.push(`/trainers/platform/members/${this.$route.params.id}/checkups`)
  }

  render (h: CreateElement) {
    return <Wizard basePath={`/trainers/checkup/${this.$route.params.id}`}
                   closeCallback={this.closeBuilder}
                   isReadonly={this.checkupAction === 'view'} />
  }

  beforeMount () {
    if (this.$route.query) {
      this.checkupAction = this.$route.query.action || ''
    }
  }
}
